import React from "react";
import { PLEDGE_COLUMNS } from "./pledgeTableConfig";

const PledgeTableHeader = () => (
  <thead>
    <tr className="table-header table-row">
      {PLEDGE_COLUMNS.map(col => (
        <th key={col.key} className={col.align}>
          {col.label}
        </th>
      ))}
    </tr>
  </thead>
);

export default PledgeTableHeader;



// WEBPACK FOOTER //
// ./src/components/applicationsComponents/applicationsCommon/PledgeTableHeader.jsx